"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmPhoneViewContainer = void 0;
var _SourceProvider = require("../SourceProvider");
var _ConfirmPhoneView = require("./ConfirmPhoneView");
const ConfirmPhoneViewContainer = exports.ConfirmPhoneViewContainer = (0, _SourceProvider.SourceProvider)(_ConfirmPhoneView.ConfirmPhoneView);